import React from "react";
import Person from "@material-ui/icons/Person";
import RestaurantMenuIcon from "@material-ui/icons/RestaurantMenu";
import Language from "@material-ui/icons/Language";

const DashboardPage = React.lazy(() => import("../views/Dashboard/Dashboard.js"));
const GelenSiparisler = React.lazy(() => import("../views/Siparisler/GelenSiparisler.js"));
const Menu = React.lazy(() => import("../views/Menu/Menu.jsx"));
const TableSettings = React.lazy(() => import("../views/Masalar/tableSettings.jsx"));
const RestaurantSettings = React.lazy(() => import("../views/Settings/RestaurantSettings.js"));
const New_Masalar = React.lazy(() => import("../views/Masalar/new_masalar.jsx"));
const NewDashboard = React.lazy(() => import("../views/Dashboard/NewDashboard"));
const Stok = React.lazy(() => import("../views/Stok/Stok.js"));
const Muhasebe = React.lazy(() => import("../views/Muhasebe/Muhasebe.js"));
const OrdersTable = React.lazy(() => import("../views/Tablolar/Siparisler"));
const SonAramalar = React.lazy(() => import("../views/Arama/SonAramalar.js"));
const CancelledOrdersPage = React.lazy(() => import("../views/Dashboard/CancelledOrdersPage"));

export const routesWithUserSystem = [
  {
    path: "/rapor",
    name: "Ana Sayfa",
    rtlName: "لوحة القيادة",
    icon: Person,
    component: DashboardPage,
    layout: "/admin",
    mainPanelHidden: true,
  },
  {
    path: "/siparisler",
    name: "Gelen Siparişler",
    icon: "content_paste",
    component: GelenSiparisler,
    layout: "/admin",
  },
  {
    path: "/stok",
    name: "Stok",
    icon: "content_paste",
    component: Stok,
    layout: "/admin",
    mainPanelHidden: true,
  },
  {
    path: "/muhasebe",
    name: "Muhasebe",
    icon: "content_paste",
    component: Muhasebe,
    layout: "/admin",
    mainPanelHidden: true,
  },
  /*
  {
    path: "/typography",
    name: "asd",
    rtlName: "طباعة",
    icon: LibraryBooks,
    component: Typography,
    layout: "/admin",
  },
  {
    path: "/",
    name: "Stok",
    rtlName: "الرموز",
    icon: BubbleChart,
    component: Icons,
    layout: "/admin",
  },
  {
    path: "/",
    name: "Muhasebe",
    rtlName: "خرائط",
    icon: LocationOn,
    component: Maps,
    layout: "/admin",
  },
  {
    path: "/",
    name: "İstatistik / Raporlama",
    rtlName: "خرائط",
    icon: LocationOn,
    component: Maps,
    layout: "/admin",
  },*/
  {
    path: "/menu",
    name: "Menü",
    rtlName: "إخطارات",
    icon: RestaurantMenuIcon,
    component: Menu,
    layout: "/admin",
  },
  {
    path: "/masalar",
    name: "deneme",
    rtlName: "إخطارات",
    icon: RestaurantMenuIcon,
    component: New_Masalar,
    layout: "/admin",
    tabletAllowed: true,
  },
  {
    path: "/",
    name: "dash",
    rtlName: "إخطارات",
    icon: RestaurantMenuIcon,
    component: NewDashboard,
    layout: "/admin",
  },
  {
    path: "/ayarlar/masa",
    name: "Masa Ayarları",
    rtlName: "پشتیبانی از راست به چپ",
    icon: Language,
    component: TableSettings,
    layout: "/admin",
    mainPanelHidden: true,
  },
  {
    path: "/ayarlar",
    name: "Restoran Ayarları",
    rtlName: "پشتیبانی از راست به چپ",
    icon: Language,
    component: RestaurantSettings,
    layout: "/admin",
    mainPanelHidden: true,
  },
  {
    path: "/siparis-listesi",
    name: "Geçmiş Siparişler",
    rtlName: "پشتیبانی از راست به چپ",
    icon: Language,
    component: OrdersTable,
    layout: "/admin",
    mainPanelHidden: true,
  },
  {
    path: "/iptal-siparisler",
    name: "İptal Edilen Siparişler",
    rtlName: "إخطارات",
    icon: Language,
    component: CancelledOrdersPage,
    layout: "/admin",
    mainPanelHidden: true,
  },

  /*{
    path: "/premium",
    name: "Premium'a Yükselt",
    rtlName: "التطور للاحترافية",
    icon: Unarchive,
    component: null,
    layout: "/admin",
  },*/
];
const routes = [
  {
    path: "/rapor",
    name: "Ana Sayfa",
    rtlName: "لوحة القيادة",
    icon: Person,
    component: DashboardPage,
    layout: "/admin",
    mainPanelHidden: true,
  },
  {
    path: "/siparisler",
    name: "Gelen Siparişler",
    icon: "content_paste",
    component: GelenSiparisler,
    layout: "/admin",
  },
  {
    path: "/stok",
    name: "Stok",
    icon: "content_paste",
    component: Stok,
    layout: "/admin",
    mainPanelHidden: true,
  },
  {
    path: "/muhasebe",
    name: "Muhasebe",
    icon: "content_paste",
    component: Muhasebe,
    layout: "/admin",
    mainPanelHidden: true,
  },
  {
    path: "/menu",
    name: "Menü",
    rtlName: "إخطارات",
    icon: RestaurantMenuIcon,
    component: Menu,
    layout: "/admin",
  },
  {
    path: "/masalar",
    name: "deneme",
    rtlName: "إخطارات",
    icon: RestaurantMenuIcon,
    component: New_Masalar,
    layout: "/admin",
    tabletAllowed: true,
  },
  {
    path: "/siparis-listesi",
    name: "Sipariş Listesi",
    rtlName: "إخطارات",
    icon: RestaurantMenuIcon,
    component: OrdersTable,
    layout: "/admin",
    mainPanelHidden: true,
  },
  {
    path: "/iptal-siparisler",
    name: "İptal Edilen Siparişler",
    rtlName: "إخطارات",
    icon: Language,
    component: CancelledOrdersPage,
    layout: "/admin",
    mainPanelHidden: true,
  },
  {
    path: "/",
    name: "dash",
    rtlName: "إخطارات",
    icon: RestaurantMenuIcon,
    component: NewDashboard,
    layout: "/admin",
  },
  {
    path: "/ayarlar/masa",
    name: "Masa Ayarları",
    rtlName: "پشتیبانی از راست به چپ",
    icon: Language,
    component: TableSettings,
    layout: "/admin",
    mainPanelHidden: true,
  },
  {
    path: "/ayarlar",
    name: "Restoran Ayarları",
    rtlName: "پشتیبانی از راست به چپ",
    icon: Language,
    component: RestaurantSettings,
    layout: "/admin",
    mainPanelHidden: true,
  },
  {
    path: "/siparis-listesi",
    name: "Geçmiş Siparişler",
    rtlName: "پشتیبانی از راست به چپ",
    icon: Language,
    component: OrdersTable,
    layout: "/admin",
    mainPanelHidden: true,
  },
  {
    path: "/son-aramalar",
    name: "Son Aramalar",
    rtlName: "پشتیبانی از راست به چپ",
    icon: Language,
    component: SonAramalar,
    layout: "/admin",
  },

];

export default routes;
